import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { NumericFormat } from "react-number-format";
import PageInfo from "../UI/PageInfo";
import FieldDisabled from "../FieldDisabled";
import width from "./helper";

class WageInput extends React.Component {
  constructor() {
    super();

    this.state = {
      value: null,
    };
  }
  componentDidMount() {
    this.setState({ value: this.props.input.value });
  }

  componentDidUpdate(prevProps) {
    const new_value = this.props.input.value;
    if (prevProps.input.value !== new_value) {
      this.setState({ value: new_value });
    }
  }

  render() {
    const {
      shouldHide,
      schemaProps,
      input,
      formApi,
      disabledViaReuse,
    } = this.props;
    
    const { labelPostfix, info, maxLength, placeholder, disabled, disableWhenField } = schemaProps;

    // Calculate isDisabled based on disableWhenField logic (same as RadioInput)
    let isDisabled = false;
    if (disabled && disableWhenField !== undefined) {
      if (typeof disableWhenField === "string") {
        isDisabled = FieldDisabled(disabled, disableWhenField, formApi);
      } else if (Array.isArray(disableWhenField)) {
        isDisabled = FieldDisabled(
          disabled,
          disableWhenField,
          formApi,
          undefined,
          disableWhenField
        );
      } else if (typeof disableWhenField === "function") {
        isDisabled = disableWhenField(formApi.getState().values);
      } else {
        isDisabled = FieldDisabled(
          disabled,
          disableWhenField.when,
          formApi,
          undefined,
          disableWhenField.is
        );
      }
    } else if (!!disabledViaReuse) {
      isDisabled = disabledViaReuse;
    } else {
      isDisabled = disabled;
    }

    let formRowClasses = classNames("form-row-dimension", {
      [`mobile-lg:grid-col-12`]: true,
    });

    let wrapperClass = classNames("grid-row", {
      "input-hide": shouldHide === true,
    });

    let inputContainerClass = classNames("grid-row", "flex-wrap", {
      [`mobile-lg:grid-col-12`]: true,
    });

    let inputRowClassesBox = classNames("input-wage", "grid-row", "flex-wrap");

    let inputRowClassesText = classNames("usa-input-inline_text");

    const wageRateStyle = {
      backgroundColor: "#ffffff",
      border: "1px solid #5B616B",
      height: "2.5rem",
      marginTop: ".5rem",
      maxWidth: "30rem",
      padding: ".5rem",
    };
    const disabledStyle = {
      color: "#c9c9c9",
      border: "1px solid #c9c9c9",
    }

    return (
      <div className="wage-range">
        <div className={wrapperClass}>
          <div>{info && info.position === "top" && <PageInfo {...info} />}</div>
          <div className={formRowClasses}>
            <div className={inputContainerClass}>
              <div className={inputRowClassesBox}>
                <NumericFormat
                  style={isDisabled ? disabledStyle : wageRateStyle}
                  name={input.name}
                  placeholder={placeholder || "$nnnn.nn"}
                  prefix={"$"}
                  value={this.state.value}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  allowNegative={false}
                  onValueChange={(values) => {
                    let beforeDecVal = values.value.split(".")[0];
                    if (beforeDecVal.length <= maxLength) {
                      input.onChange(values.value);
                      this.setState({ value: values.value });
                    } else if (beforeDecVal.length > maxLength) {
                      this.setState({ value: this.state.value });
                    }
                  }}
                  onBlur={(e) => {
                    formApi.mutators.setFieldTouched(input.name, true);
                  }}
                  disabled={isDisabled}
                  className={
                    isDisabled
                      ? `usa-input usa-input-disabled`
                      : `usa-input grid-col-${width(schemaProps)}`
                  }
                />
                {labelPostfix && (
                  <div>
                    <div
                      style={{ paddingLeft: 10 }}
                      className={inputRowClassesText}
                    >
                      {labelPostfix}
                    </div>
                    <label
                      htmlFor={`${input.name}-from`}
                      className="usa-sr-only"
                    >
                      {labelPostfix}
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            {info && info.position === undefined && <PageInfo {...info} />}
          </div>
        </div>
      </div>
    );
  }
}

WageInput.defaultProps = {
  id: Math.floor(Math.random() * 100000),
  width: 4,
  maxLength: 4,
};

WageInput.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.number,
  maxLength: PropTypes.number,
};

export default WageInput;
